import React, { useState, useEffect } from 'react';
import './ScrollArrow.css';

const ScrollArrow = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    let scrollTimer = null;
    let showTimer = null;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isCurrentlyAtTop = scrollY < 100; // Consider "top" as first 100px
      
      setIsAtTop(isCurrentlyAtTop);
      
      // Hide arrow immediately when scrolling
      setIsVisible(false);
      
      // Clear existing timers
      if (scrollTimer) clearTimeout(scrollTimer);
      if (showTimer) clearTimeout(showTimer);
      
      // If at top, start timer to show arrow after no scroll for 3 seconds
      if (isCurrentlyAtTop) {
        scrollTimer = setTimeout(() => {
          showTimer = setTimeout(() => {
            setIsVisible(true);
          }, 3000); // Show after 3 seconds of no scroll
        }, 100); // Small delay to ensure scroll has stopped
      }
    };

    // Initial check
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimer) clearTimeout(scrollTimer);
      if (showTimer) clearTimeout(showTimer);
    };
  }, []);

  // Only render if at top
  if (!isAtTop) return null;

  return (
    <div 
      className={`scroll-arrow ${isVisible ? 'visible' : 'hidden'}`}
    >
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="arrow-icon"
      >
        <path 
          d="M12 4V20M12 20L18 14M12 20L6 14" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ScrollArrow;